import cx from "classnames";

export const getIconClass = (state: boolean): string =>
  cx(
    "far",
    "fa-fw",
    state ? "fa-check-circle text-success" : "fa-exclamation-triangle text-danger"
  );
export const openCloudFarmPage = (
  startDate: number, //timestamp
  endDate: number //timestamp
) =>
  window.open(
    `/apps/cloudfarm/?created_from=${startDate * 1000}&created_to=${endDate * 1000}`,
    "_self"
  );
export const openRecordPage = (
  recordState: "performed" | "planned" | "concept" | "adviced",
  startDate: string, //YYYY-MM-DD
  endDate: string //YYYY-MM-DD
) => {
  localStorage.setItem(
    "record_stream_filter",
    JSON.stringify({ state: [recordState], period: { start: startDate, end: endDate } })
  );
  window.open("/cropr/record/record/", "_self");
};
export const calcPct = (value: number, total: number): number =>
  /*Calculate percentages. Makes sure the percentages are never larger than 100 and never smaller than 5% (or it becomes too small). */
  Math.max(5, Math.min(100, (100 * value) / total));
